import React from "react"
import { graphql } from "gatsby"

import { CloseOutline } from "@styled-icons/evaicons-outline/CloseOutline"

import { Bookmark } from "@styled-icons/foundation/Bookmark"

import Layout from "../components/Layout"
import SEO from "../components/seo"
import PostItem from "../components/PostItem"
import Pagination from "../components/Pagination"
import NotFound from "../components/404"

import HeroPost from "../components/HeroPost"

import {
  FilterHeader,
  Content,
  Tag,
  Posts,
  Icon,
  NumberPosts,
  Close,
} from "../components/FilterHeader/styled"

import { ListWrapper } from "../components/ListWrapper/styled"

const BlogFiltered = props => {
  const postList = props.data.allMarkdownRemark.edges

  const isEmpty = postList.length === 0 ? true : false

  // valor no contexto da page em gastby node
  const { currentPage, numPagesByCategory, filterBy } = props.pageContext

  const isFirst = currentPage === 1
  const isLast = currentPage === numPagesByCategory
  const filterLowerCase = filterBy.toLowerCase()
  const prevPage =
    currentPage - 1 === 1
      ? `/posts/tag/${filterLowerCase}/`
      : `/posts/tag/${filterLowerCase}/page/${currentPage - 1}`
  const nextPage = `/posts/tag/${filterLowerCase}/page/${currentPage + 1}`

  const filterTitle = filterBy.charAt(0).toUpperCase() + filterBy.slice(1)
  return (
    <Layout>
      <SEO title={filterTitle} />
      <HeroPost />
      <FilterHeader>
        <Content>
          <Tag>
            <span>{filterTitle}</span>
            <Close href="/posts">
              <CloseOutline />
            </Close>
          </Tag>
          <Posts>
            <Icon>
              <Bookmark />
            </Icon>
            <NumberPosts>{postList.length} posts</NumberPosts>
          </Posts>
        </Content>
      </FilterHeader>
      <ListWrapper>
        {isEmpty && <NotFound />}

        {postList.map(
          ({
            node: {
              fields: { slug },
              frontmatter: {
                background,
                imageDescription,
                category,
                author,
                title,
              },
            },
          }) => (
            <PostItem
              key={slug}
              slug={slug}
              imageDescription={imageDescription}
              background={background}
              category={category}
              author={author}
              title={title}
            />
          )
        )}
      </ListWrapper>
      {!isEmpty && (
        <Pagination
          isFirst={isFirst}
          isLast={isLast}
          currentPage={currentPage}
          numPages={Math.ceil(postList.length / 9)}
          prevPage={prevPage}
          nextPage={nextPage}
          url={`tag/${filterBy}`}
        />
      )}
    </Layout>
  )
}

export const query = graphql`
  query PostFilter($skip: Int!, $limit: Int!, $filterBy: String) {
    allMarkdownRemark(
      sort: { fields: frontmatter___date, order: DESC }
      limit: $limit
      skip: $skip
      filter: { frontmatter: { category: { eq: $filterBy } } }
    ) {
      edges {
        node {
          fields {
            slug
          }
          frontmatter {
            background
            imageDescription
            category
            author
            date(locale: "pt-br", formatString: "DD [de] MMMM [de] YYYY")
            description
            title
          }
          timeToRead
        }
      }
    }
  }
`

export default BlogFiltered
